import {
  type CreateBatchOffersBody,
  createBatchOffersBodySchema,
  type CreateBatchOffersResponse,
  createBatchOffersResponseSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { isDefined } from "@clipboard-health/util-ts";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";

import { cacheOffer } from "../../Open/useCreateOffer";

export const CREATE_BATCH_OFFERS_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/offers/batch`;

export function toCreateBatchOfferBody(shiftIds: string[]): CreateBatchOffersBody {
  return {
    data: {
      type: "offer",
      relationships: {
        shifts: { data: shiftIds.map((shiftId) => ({ type: "open-shift", id: shiftId })) },
      },
    },
  };
}

export function useCreateBatchOffers(
  options: UseMutationOptions<CreateBatchOffersResponse, AxiosError, CreateBatchOffersBody> = {}
): UseMutationResult<CreateBatchOffersResponse, AxiosError, CreateBatchOffersBody> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateBatchOffersBody) => {
      const response = await post({
        url: CREATE_BATCH_OFFERS_URL,
        data,
        requestSchema: createBatchOffersBodySchema,
        responseSchema: createBatchOffersResponseSchema,
      });
      return response.data;
    },
    onSuccess: (newOffers) => {
      newOffers.data.forEach((offer) => {
        if (isDefined(offer.relationships?.shift?.data?.id)) {
          cacheOffer(queryClient, {
            shiftId: offer.relationships?.shift?.data?.id,
            offer: { data: offer },
          });
        }
      });
    },
    ...options,
  });
}
